import { Box, Grid, HStack, Icon, Stack, StackDivider, Text, useDisclosure, VStack } from '@chakra-ui/react';
import React, { useCallback } from 'react';
import { getKycV2StatusColor } from '@utils';
import { useNavigate } from 'react-router-dom';
import { formatDate } from '@utils/dateUtils';
import { getProviderDashboardConfigOrNull } from '@views/Kyc/kycUiUtils';
import { RxDashboard } from 'react-icons/rx';
import ModalLayout from '@components/Modal/ModalLayout';
import JsonViewer from '@components/Modal/JsonViewer';


const KycCard = ({ kyc }) => {
  const { userId, kycStatus, createDate, product, provider, subProvider, providerClientId, rejectionReasons } = kyc;
  const navigate = useNavigate();
  const {
    isOpen: isJsonViewerOpen,
    onOpen: onJsonViewerOpen,
    onClose: onJsonViewerClose
  } = useDisclosure();

  const handleDashboardLinkClick = useCallback(
    () =>
      window.open(
        getProviderDashboardConfigOrNull(provider).url.replace(
          '{clientId}',
          providerClientId
        )
      ),
    [kyc]
  );

  const handleJsonViewClose = () => {
    onJsonViewerClose();
  };

  return (
    <VStack
      bg="backGround"
      borderRadius="12px"
      w={'52rem'}
      maxW={'100%'}
      divider={<StackDivider style={{ margin: '0' }} borderColor="whiteAlpha.300" />}
      onClick={() =>
        navigate(`/user/${userId}/kyc/product/${product}/provider/${provider}/sub-provider/${subProvider}`)
      }
      cursor={'pointer'}
    >
      {(
        <ModalLayout
          isOpen={isJsonViewerOpen}
          onClose={handleJsonViewClose}
          size={'md'}
        >
          <JsonViewer
            title={
              "Rejection reasons"
            }
            subTitle={`Reason`}
            jsonString={JSON.stringify(Array.from(rejectionReasons || []),null, 2)}
          />
        </ModalLayout>
      )}
      <Grid
        templateColumns={{ base: '1fr', md: '1fr 1fr 1fr' }}
        w="90%"
        m="1rem"
        gap={4}
        alignItems="flex-start"
      >
        <Box>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray">
            User ID:
          </Text>
          <Text fontSize="sm" color="gray">
            {userId}
          </Text>
        </Box>

        <HStack>
          <Icon
            viewBox="0 0 200 200"
            color={getKycV2StatusColor(kycStatus)}
            w="8px"
          >
            <path
              fill="currentColor"
              d="M 100, 100 m -75, 0 a 75,75 0 1,0 150,0 a 75,75 0 1,0 -150,0"
            />
          </Icon>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
            {kycStatus}
          </Text>
        </HStack>

        <Box>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="gray">
            Created on:
          </Text>
          <Text fontSize={{ base: 'sm', sm: 'md' }} color="white">
            {formatDate(createDate)}
          </Text>
        </Box>
      </Grid>

      <Grid
        gridTemplateColumns="1fr"
        gap={2}
        display="flex"
        flexDirection={{ base: 'column', md: 'row' }}
        justifyContent={{base:"flex-start", md: "space-between"}}
        w="90%"
        m="1rem"
        textAlign="start"
      >
        {rejectionReasons && Array.from(rejectionReasons).length > 0 && (
          <Box
            cursor="pointer"
            _hover={{ textDecoration: 'underline' }}
            onClick={(e) => {
              e.stopPropagation();
              onJsonViewerOpen();
            }}
          >
            <Text>
              View Rejection Reasons
            </Text>
          </Box>
        )}
        {getProviderDashboardConfigOrNull(provider) !== null && (
          <Stack
            color={'white'}
            cursor={'pointer'}
            _hover={{ textDecor: 'underline' }}
            onClick={handleDashboardLinkClick}
          >
            <Text display={'flex'} alignItems={'center'} gap={1}>
              {getProviderDashboardConfigOrNull(provider).text}
              <RxDashboard display={'inline'} />
            </Text>
          </Stack>
        )}
      </Grid>
    </VStack>

  );
};

export default KycCard;
